import {
    Component,
    Input,
    Output,
    EventEmitter,
    ContentChildren,
    QueryList,
    TemplateRef,
    AfterContentInit,
    OnInit
} from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'app-prime-dynamic-table',
    templateUrl: './app-prime-dynamic-table.component.html',
    styleUrls: ['./app-prime-dynamic-table.component.scss'],
    standalone: false
})
export class AppPrimeDynamicTableComponent implements OnInit, AfterContentInit {
    @Input() value: any[] = [];
    @Input() cols: any[] = [];
    @Input() totalRecords: number = 0;
    @Input() loading: boolean = false;
    @Input() rows: number = 10;
    @Input() scrollHeight: string = '400px';
    @Input() rowsPerPageOptions: number[] = [5, 10, 20];
    @Input() resizableColumns: boolean = true;
    @Input() scrollable: boolean = true;
    @Input() paginatorPosition: 'top' | 'bottom' | 'both' = 'bottom';
    @Input() tableStyle = { 'min-height': 'calc(100vh - 140px)' };
    @Output() onLazyLoad = new EventEmitter<TableLazyLoadEvent>();


    @ContentChildren(PrimeTemplate) templates: QueryList<PrimeTemplate>;
    headerTemplate: TemplateRef<any>;
    bodyTemplate: TemplateRef<any>;
    
    ngOnInit(): void {
       //TODO: Initialize any required data or perform setup tasks here (If needed in the future)
    }
    ngAfterContentInit() {
        this.templates.forEach(item => {
            switch (item.getType()) {
                case 'header':
                    this.headerTemplate = item.template;
                    break;
                case 'body':
                    this.bodyTemplate = item.template;
                    break;
            }
        });
    }
}
